// 节日福利
export const holidayWelfareRouter = [
  {
    path: '/holidayWelfare/PosterTemplate',
    name: 'PosterTemplate',
    component: () => import('../views/holidayWelfare/PosterTemplate')
  }
];